import React from 'react';
import { AppBar, Box, Toolbar, Typography } from '@mui/material';
import s from './Navbar.module.scss';

export default function Navbar() {
    return (
        <AppBar position="sticky" elevation={0} className={s.appbar}>
            <Toolbar className={s.toolbar}>
                <Box className={s.brand}>
                    <Typography variant="h6" className={s.brandTitle}>BSP Admin</Typography>
                    <Typography variant="body2" className={s.brandSub}>Catalog management</Typography>
                </Box>
            </Toolbar>
        </AppBar>
    );
}
